import React from "react";
import { createRoot, type Root } from "react-dom/client";
import { canv } from "@/canv/global";
import { logException, sleep } from "@/canv/utils";
import styles from "./ReconnectWindow.module.css";
import { ReconnectWindowLayout } from "./ReconnectWindowLayout";

export class ReconnectWindow {
    async show() {
        // Не показываем окно переподключения во время экспорта PDF
        if (canv.isHighPdfExporting) {
            return;
        }

        this.wrapper = document.createElement("div");
        this.wrapper.classList.add(styles.reconnectWindowWrapper);

        const reconnectWindowLayout = React.createElement(ReconnectWindowLayout);

        this.root = createRoot(this.wrapper);
        this.root.render(reconnectWindowLayout);
        this.showed = true;

        document.body.appendChild(this.wrapper);

        await sleep(500);

        try {
            // бесконечно ждем переподвключения
            await canv.connectAndLoadCanvas();
            this.hide();
        } catch (e) {
            this.hide();
            logException(e);
            return;
        }
    }

    hide() {
        this.root?.unmount();
        this.wrapper?.parentNode?.removeChild(this.wrapper);
        this.showed = false;
    }

    showed = false;
    root: Root | null = null;
    wrapper: HTMLElement | null = null;
}
